export default function WhySection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider uppercase text-accent-700 bg-accent-100 rounded-full mb-4">
            Dlaczego warto?
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
            Dlaczego Kakobuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            Kakobuy Spreadsheet pomaga użytkownikom szybciej znaleźć najlepsze produkty bez godzinnego przeszukiwania chińskich platform.
          </p>
        </div>

        <div className="overflow-hidden rounded-2xl border border-background-200/70 bg-background-50">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[600px]">
              <thead>
                <tr className="border-b border-background-200/70">
                  <th className="px-6 py-4 text-left text-sm font-semibold text-foreground-700 bg-background-100">
                    Funkcja
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-semibold text-foreground-500 bg-background-100">
                    Bez Spreadsheet
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-semibold text-primary-700 bg-primary-50/50">
                    Kakobuy Spreadsheet
                  </th>
                </tr>
              </thead>
              <tbody>
                {[
                  { feature: 'Szukanie produktów', without: 'Trudne', with: 'Gotowe listy' },
                  { feature: 'Linki', without: 'Ręczne wyszukiwanie', with: 'Jeden klik' },
                  { feature: 'Kategorie', without: 'Brak', with: 'Posegregowane' },
                  { feature: 'Opinie', without: 'Brak', with: 'Porównania' },
                  { feature: 'Oszczędność czasu', without: 'Niska', with: 'Wysoka' },
                ].map((row, i) => (
                  <tr
                    key={row.feature}
                    className={i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}
                  >
                    <td className="px-6 py-4 text-sm font-medium text-foreground-800">
                      {row.feature}
                    </td>
                    <td className="px-6 py-4 text-sm text-center text-foreground-500">
                      {row.without}
                    </td>
                    <td className="px-6 py-4 text-sm text-center font-medium text-primary-700">
                      {row.with}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-12">
          {[
            { icon: 'ri-time-line', title: 'Oszczędność czasu', desc: 'Znajdź produkty w minuty, nie godziny' },
            { icon: 'ri-shield-check-line', title: 'Sprawdzone linki', desc: 'Weryfikowane przez społeczność' },
            { icon: 'ri-price-tag-3-line', title: 'Najlepsze ceny', desc: 'Aktualne porównania cenowe' },
            { icon: 'ri-customer-service-2-line', title: 'Polskie wsparcie', desc: 'Poradniki dla Polaków' },
          ].map((item) => (
            <div
              key={item.title}
              className="p-5 bg-background-50 rounded-xl border border-background-200/50"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3">
                <i className={item.icon} />
              </span>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-500">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}